import { Button, Typography, withStyles } from '@material-ui/core';
import styled from 'styled-components';
import { ChangePasswordButtonBackgroundColorByCurrentApp } from '../../utils/get-app-env';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background-color: #fff;
  padding: 40px 60px;
  width: 100%;
  max-width: 500px;
  border-radius: 10px;

  header {
  
    h1 {
      text-align: center;
      color: #2f2f2f;
    }
  }

  footer > button {
    width: 100%;
  }
`;

export const ModalBody = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;


export const ChangePasswordSaveButton = withStyles((theme) => ({
  root: {
    backgroundColor: ChangePasswordButtonBackgroundColorByCurrentApp(),
    borderRadius: 6,
    color: '#FFF !important',
    padding: '0px 16px',
    height: 45,
    '&:disabled': {
      color: '#7f7f7f !important',
      fill: '#FFF',
      '&:disabled .save-button-typography': {
        fill: "#FFF",
        color: "#7f7f7f !important",
      },
    },
    
    '&:hover': {
      backgroundColor: ChangePasswordButtonBackgroundColorByCurrentApp()+'99',
      fill: "#FFF",
      color: "#FFF",
      '&:hover .save-button': {
        fill: "#FFF",
        color: "#FFF",
      },
    },
  }
}))(Button);


export const ChangePasswordButtonTypography = withStyles((theme) => ({
  root: {
    fontSize: 16,
    fontWeight: 400,
    color: '#fff'
  }
}))(Typography);

export const ChangePasswordTitleTypography = withStyles((theme) => ({
  root: {
    fontSize: 28,
    fontWeight: 400,
    color: '#7f7f7f',
    textAlign: 'center',
  }
}))(Typography);